import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/contract/purchase";

/**
 * 路桥-采购合同台账
 *
 * 台账明细只存商品id，商品名称/规格/单位等由后端按 id 回查组装。
 */
export default {
    /** 按合同编号汇总查询 */
    queryContractList: (data) => axios.get({url: `${PREFIX_URI}/queryContractList`, data}),
    /** 查询全部合同编号（入库单/出库单选择采购合同用） */
    queryContractNoPage: (data = {}) => axios.get({url: `${PREFIX_URI}/queryContractNoPage`, data}),
    /** 查询某个合同下的台账明细 */
    queryItemList: (contractNumber) => axios.get({url: `${PREFIX_URI}/queryItemList`, data: {contractNumber}}),
    /** 确保合同二维码存在（已有直接返回，没有则生成并保存），返回图片地址 */
    ensureQrCode: (contractNumber) => axios.get({url: `${PREFIX_URI}/ensureQrCode`, data: {contractNumber}}),
    /** 上传excel：同步商品并返回台账明细（不保存台账） */
    importExcel: (formData) => axios.post({url: `${PREFIX_URI}/importExcel`, data: formData}),
    /** 保存台账明细：1 覆盖更新，2 追加更新 */
    submit: (data) => axios.post({url: `${PREFIX_URI}/submit`, data}),
}
